import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { installRuntimeEnhancements } from './runtimeEnhancements';
import './styles.css';
import './advisor.css';
import './process-wizard.css';
import './convertx-operating-system.css';
import './convertx-brand-theme.css';

installRuntimeEnhancements();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
